import PlatformFooter from "./PlatformFooter"

export default PlatformFooter
